"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
exports.TwoColumnLayout = function (_a) {
    var children = _a.children, _b = _a.fill, fill = _b === void 0 ? true : _b;
    return (react_1.default.createElement(creator_ui_1.Flexbox, { flexDirection: "column", height: fill ? "100%" : "auto" }, children));
};
exports.TwoColumnLayout.displayName = "TwoColumnLayout";
